<template>
    <UiSearchboxJetparkSearchBox
        v-editable="blok"
        data-test="sb-jetpark-searchbox"
        :terminals="blok.terminals"
        :initial-airport-code="initialAirportCode"
        :initial-terminal="initialTerminal"
    />
</template>

<script setup lang="ts">
import { useQuoteStore } from '../../../../apps/l4/app/store/quote';

defineProps<{ blok: any }>();

const route = useRoute();
const quoteStore = useQuoteStore();

const initialAirportCode = computed(() => {
    const slugParam = route.params.slug;

    if (slugParam) {
        const parts = Array.isArray(slugParam) ? slugParam : [slugParam];
        const last = String(parts[parts.length - 1]);
        const code = last.split('-').pop();

        if (code && code.length === 3) {
            return code.toUpperCase();
        }
    }

    return quoteStore.getAllData?.startDestination?.code ?? null;
});

const initialTerminal = computed(() => {
    return quoteStore.getAllData?.terminal ?? null;
});
</script>
